import { useState } from 'react';

import { StyledNoImage } from './styles';

interface ImageWithFallbackProps {
  imageUrl: string;
}

export const ImageWithFallback = ({ imageUrl }: ImageWithFallbackProps) => {
  const [imageError, setImageError] = useState(false);

  return (
    <>
      {imageError ? (
        <StyledNoImage iconName="no_image_available" />
      ) : (
        <img src={imageUrl} onError={() => setImageError(true)} />
      )}
    </>
  );
};
